import './LandingPage.css';
import BackGround from '../../PageAssets/Photos/DesktopBackground.png'


const LandingPage = () => { 


    return (
        <div id='LandingPageMainContainer'>

            <div className='MottoParagrafMainDiv'>
             <p className='MottoParagraf'>Rozwój zaczyna się tam, gdzie kończy się strach.</p>
             <p className='MottoParagraf'>Skok o tyczce to sport dla tych,</p>
             <p className='MottoParagraf'>którzy nie boją się marzyć wysoko.</p>
            </div>

           <img src={BackGround} alt="Opis zdjęcia" className='LandingPageMainPhoto1' />

        </div>
    )
}

export default LandingPage;